module.exports = __webpack_public_path__ + "img/Zona pet.b9c44498.png";